import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatRadioModule } from '@angular/material/radio';
import {  MatFormFieldModule } from '@angular/material/form-field';
import { MatTabsModule } from '@angular/material/tabs';
import {  MatInputModule } from '@angular/material/input';
import {  MatButtonModule } from '@angular/material/button';
import {  MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatListModule } from '@angular/material/list';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

import { HasPlansPipeModule } from 'src/app/shared/pipes/has-plans';
import { IsFeatureFlagEnabledPipeModule, OrderByPipeModule } from 'src/app/shared/pipes';

import { AccountIntentComponent, IntentComponent, DeleteTopicConfirmationComponent, IntentRecommendationWizardComponent } from './components';
import { IntentDataTopicCountPipe } from './pipes/intent-data-topic-count.pipe';
import { ExistingTopicsFilterPipe } from './pipes/existing-topics-filter.pipe';
import { TopicsFilterPipe } from './pipes/topics-filter.pipe';
import { CollapsedCategoriesFilterPipe } from './pipes/collapsed-categories-filter.pipe';
import { SiModalModule } from '../../components';
import { AccountIntentContainerComponent } from './containers';
import { DisableAutocompleteDirectiveModule } from 'src/app/shared/directives';

@NgModule({
    declarations: [
        AccountIntentContainerComponent,
        AccountIntentComponent,
        IntentComponent,
        IntentDataTopicCountPipe,
        ExistingTopicsFilterPipe,
        TopicsFilterPipe,
        CollapsedCategoriesFilterPipe,
        DeleteTopicConfirmationComponent,
        IntentRecommendationWizardComponent,
    ],
    imports: [
        DisableAutocompleteDirectiveModule,
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ScrollingModule,
        HasPlansPipeModule,
        IsFeatureFlagEnabledPipeModule,
        MatRadioModule,
        MatFormFieldModule,
        MatTabsModule,
        MatInputModule,
        MatButtonModule,
        OrderByPipeModule,
        SiModalModule,
        MatProgressSpinnerModule,
        MatListModule,
        FontAwesomeModule,
    ],
    exports: [AccountIntentContainerComponent, IntentComponent]
})
export class IntentModule {
}
